export const buttonsRegistry = (editor) => {
  editor.ui.registry.addButton('calloutInfo', {
    icon: "info-icon",
    tooltip: "Info",
    onAction: () => editor.execCommand("a51ToggleCallout", "aside-info"),
  });

  editor.ui.registry.addButton("calloutSuccess", {
    icon: "checkbox-circle",
    tooltip: "Success",
    onAction: () => editor.execCommand("a51ToggleCallout", "aside-success"),
  });

  editor.ui.registry.addButton("calloutAlert", {
    icon: "alert",
    tooltip: "Alert",
    onAction: () => editor.execCommand("a51ToggleCallout", "aside-alert"),
  });

  editor.ui.registry.addButton("calloutGeneral", {
    icon: "info-icon",
    tooltip: "General",
    onAction: () => editor.execCommand("a51ToggleCallout", "aside-general"),
  });

  editor.ui.registry.addButton("calloutMagic", {
    icon: "spark",
    tooltip: "Magic",
    onAction: () => editor.execCommand("a51ToggleCallout", "aside-magic"),
  });
}

export const menuOptions = (editor, menuOptions = ['info', 'success', 'alert', 'general', 'magic' ]) => {
  let items = [];
  const optionsList = options(editor);

  menuOptions.forEach(option => {
    if (optionsList[option]) {
      items.push(optionsList[option]);
    }
  })

  return items;
}

const options = (editor) => {
  return {
    info: {
      type: "menuitem",
        text: "Info",
        icon: "info-icon",
        onAction: () => editor.execCommand("a51ToggleCallout", "aside-info"),
    },
    success: {
      type: "menuitem",
        text: "Success",
        icon: "checkbox-circle",
        onAction: () => editor.execCommand("a51ToggleCallout", "aside-success"),
    },
    alert: {
      type: "menuitem",
        text: "Alert",
        icon: "alert",
        onAction: () => editor.execCommand("a51ToggleCallout", "aside-alert"),
    },
    general: {
      type: "menuitem",
        text: "General",
        icon: "info-icon",
        onAction: () => editor.execCommand("a51ToggleCallout", "aside-general"),
    },
    magic: {
      type: "menuitem",
        text: "Magic",
        icon: "spark",
        onAction: () => editor.execCommand("a51ToggleCallout", "aside-magic"),
    }
  }
}
